import React, { useCallback, useEffect, useState } from "react";
import { Row, Col, Form, Card, Input } from "antd";
import AppBaseSelect from "../../../../../core/components/baseSelect";
import { PAGINATION } from "../../_redux/constant";
import { tripodThunks } from "../../_redux/thunk";
import { useDispatch, useSelector } from "react-redux";
import TripodList from "../../components/tripod-list/tripodList";
import _ from "lodash";
import { removeVietnameseTones } from "lib/admin";
import { convertObjToArrObj } from "../../../../../lib/util";

let timer = null;
function TripodListPage() {
  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
  };
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { stations, device_models, statuses } = useSelector(
    state => state.tripod.listTripod.filterData
  );
  const { data, total, online } = useSelector(
    state => state.tripod.listTripod.tripodsInfo
  );
  const [param, setParam] = useState({
    size: PAGINATION.size,
    page: PAGINATION.page
  });
  const dataSource = _.map(data, (item, index) => ({
    ...item,
    stt:
      param.page === 1 ? index + 1 : (param.page - 1) * param.size + index + 1
  }));
  const [loadingTripodList, setLoadingTripodList] = useState(false);

  const handleGetTripodFilterData = useCallback(async () => {
    await dispatch(tripodThunks.getTripodFilterDataThunk());
  }, []);
  const _handleGetListTripod = useCallback(
    async () => {
      setLoadingTripodList(true);
      await dispatch(tripodThunks.getTripodList(param));
      setLoadingTripodList(false);
    },
    [param]
  );
  const _handleChangeInput = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      clearTimeout(timer);
      _handleChangeFilter();
    }, 800);
  };
  const _handleChangeFilter = () => {
    const filter = form.getFieldsValue();
    setParam(prev => ({
      ...prev,
      ...filter,
      station_ids: filter.station_ids
        ? filter.station_ids.join(",")
        : undefined,
      page: 1,
      size: 20
    }));
  };

  const onChangeParam = param => {
    if (!param.page && !param.size) {
      param.page = PAGINATION.page;
      param.size = PAGINATION.size;
    }
    setParam(prev => ({ ...prev, ...param }));
  };

  useEffect(
    () => {
      handleGetTripodFilterData();
      _handleGetListTripod();
    },
    [handleGetTripodFilterData, _handleGetListTripod]
  );
  return (
    <Row gutter={[8, 8]}>
      <Col span={24}>
        <Card
          bodyStyle={{ paddingBottom: "0" }}
          size="small"
          style={CARD_STYLE}
        >
          <Row align="middle" justify="space-between" span={24}>
            <Form form={form} layout={"vertical"} style={{ width: "100%" }}>
              <Row gutter={[8]}>
                <Col className="gutter-row" md={4} xs={12}>
                  <Form.Item label="Kho" name="station_ids">
                    <AppBaseSelect
                      allowConvert={true}
                      mode="multiple"
                      placeholder="Kho"
                      dataSource={stations}
                      valueKey="station_id"
                      labelKey="station_name"
                      onChange={_handleChangeFilter}
                      filterOption={(input, option) =>
                        _.includes(
                          _.toLower(removeVietnameseTones(option.label)),
                          _.toLower(removeVietnameseTones(input))
                        )
                      }
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" md={4} xs={12}>
                  <Form.Item label="Tên thiết bị" name="device_name">
                    <Input
                      allowClear
                      placeholder={"Tên thiết bị"}
                      onChange={_handleChangeInput}
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" md={4} xs={12}>
                  <Form.Item label="SN" name="device_id">
                    <Input allowClear placeholder={"SN"} onChange={_handleChangeInput} />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" md={4} xs={12}>
                  <Form.Item label="Device Model" name="device_model">
                    <AppBaseSelect
                      allowClear
                      allowConvert={true}
                      placeholder="Device Model"
                      dataSource={_.map(device_models, device_model => ({
                        key: device_model,
                        value: device_model
                      }))}
                      valueKey="key"
                      labelKey="value"
                      onChange={_handleChangeFilter}
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" md={4} xs={12}>
                  <Form.Item label="Firmware Version" name="firmware_version">
                    <Input
                      allowClear
                      placeholder={"Firmware Version"}
                      onChange={_handleChangeInput}
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" md={4} xs={12}>
                  <Form.Item label="Trạng thái" name="status">
                    <AppBaseSelect
                      allowClear
                      allowConvert={true}
                      placeholder="Trạng thái"
                      dataSource={convertObjToArrObj(statuses)}
                      valueKey="key"
                      labelKey="value"
                      onChange={_handleChangeFilter}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Row>
        </Card>
      </Col>
      <Col span={24}>
        <TripodList
          loading={loadingTripodList}
          dataSource={dataSource}
          total={total}
          online={online}
          param={param}
          onChangeParam={onChangeParam}
        />
      </Col>
    </Row>
  );
}

export default React.memo(TripodListPage);
